import React, { useState, useEffect } from 'react';
import rgbHex from 'rgb-hex';
import 'react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css';
import Switch from 'react-switch';
// import { ColorPicker } from "material-ui-color";
import ColorPicker from 'rc-color-picker';
import 'rc-color-picker/assets/index.css';
// COMPONENTS
import Header from '../../../components/header';
import BuyNow from '../../../components/buyNowSection';
import Carousel from '../../../components/carousel';
import Footer from '../../../components/footer';
// ICONS
import { FaArrowLeft } from 'react-icons/fa';
// STYLES
import '../styles.css';
import { useHistory } from 'react-router';

const DopplerColor = () => {
  const history = useHistory();
  const alreadyLoggedIn = localStorage.getItem('token');
  if (!alreadyLoggedIn) {
    history.push('/');
  }
  const [check, setCheck] = useState(false);
  const [matchColors, setMatchColors] = useState(false);
  const [show, setShow] = useState(false);
  // day colors settings
  const [dayColors, setDayColors] = useState({});
  const [hexColor, setHexColor] = useState('');
  // nigth colors settings
  const [nightColors, setNightColors] = useState({});
  const [hexNight, setHexNight] = useState('');
  // Button day colors
  const [btnDay, setBtnDay] = useState({});
  const [btnDayHex, setBtnDayHex] = useState('');
  // Button Night colors
  const [btnNight, setBtnNight] = useState({});
  const [btnNightHex, setBtnNightHex] = useState('');

  // Day colors API
  useEffect(async () => {
    await fetch('http://sandman.test/api/getDopplerColors', {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        physicalId: localStorage.getItem('physicalId'),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('FIRST_CONSOLE_RES: ', response.color);
        setDayColors(response.color);
        console.log('FIRST_CONSOLE_RES_SETTER: ', dayColors);
        const hex = rgbHex(
          parseInt(dayColors[0]),
          parseInt(dayColors[1]),
          parseInt(dayColors[2])
        );
        console.log('HEX_COLOR: ', hex);
        const hash = '#';
        setHexColor(hash.concat(hex));
        console.log('DAY_HEX_WB', hash.concat(hex));
        console.log('HEX_COLOR_NEW: ', hexColor);
      })
      .catch((error) => console.log(error));
  }, []);

  // Night colors API
  useEffect(async () => {
    await fetch('http://sandman.test/api/getDopplerColorsNight', {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        physicalId: localStorage.getItem('physicalId'),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('FIRST_CONSOLE_RES_N: ', response.color);
        setNightColors(response.color);
        console.log('FIRST_CONSOLE_RES_SET_N: ', nightColors);
        const hex = rgbHex(
          parseInt(nightColors[0]),
          parseInt(nightColors[1]),
          parseInt(nightColors[2])
        );
        console.log('HEX_COLOR: ', hex);
        const hash = '#';
        setHexNight(hash.concat(hex));
        console.log('HEX_NIGHT_WB', hash.concat(hex));
        console.log('HEX_COLOR_NEW: ', hexNight);
      })
      .catch((error) => console.log(error));
  }, []);

  // Day buttons colors API
  useEffect(async () => {
    await fetch('http://sandman.test/api/getButtonColorDay', {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        physicalId: localStorage.getItem('physicalId'),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('DAY_BTN_COLORS: ', response.color);
        setBtnDay(response.color);
        console.log('DAY_BTN_COLORS: ', btnDay);
        const hex = rgbHex(
          parseInt(btnDay[0]),
          parseInt(btnDay[1]),
          parseInt(btnDay[2])
        );
        console.log('HEX_COLOR_DAY: ', hex);
        const hash = '#';
        setBtnDayHex(hash.concat(hex));
        console.log('HEX_DAY', hash.concat(hex));
        console.log('HEX_COLOR_DAY: ', btnDayHex);
      })
      .catch((error) => console.log(error));
  }, []);

  // Night buttons colors API
  useEffect(async () => {
    await fetch('http://sandman.test/api/getButtonColorNight', {
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: localStorage.getItem('token'),
        physicalId: localStorage.getItem('physicalId'),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log('NIGHT_BTN_COLORS: ', response.color);
        setBtnNight(response.color);
        console.log('NIGHT_BTN_COLORS: ', btnNight);
        const hex = rgbHex(
          parseInt(btnNight[0]),
          parseInt(btnNight[1]),
          parseInt(btnNight[2])
        );
        console.log('HEX_COLOR_NIGHT: ', hex);
        const hash = '#';
        setBtnNightHex(hash.concat(hex));
        console.log('SUPERB_CONVERT_NIGHT:', hash.concat(hex));
        console.log('HEX_COLOR_NEW_NIGHT: ', btnNightHex);
      })
      .catch((error) => console.log(error));
  }, []);

  // show time picker -> function
  const showPicker = () => {
    setShow(!show);
  };

  return (
    <div>
      <Header />
      <BuyNow />
      <Carousel />
      <section
        class='login-bg'
        style={{ backgroundImage: 'url(./images/login-bg.jpg)' }}
      >
        <div class='container'>
          <div class='container-sm-500'>
            <a href='/settings' class='back-arrow'>
              <FaArrowLeft />
            </a>
            <h2 class='text-left'>DOPPLER COLORS</h2>
            <ul class='doppler-colors'>
              <li>
                <p>Match display and buttons color:</p>
                <div class='custom-control custom-switch'>
                  <Switch
                    onChange={() => {
                      setCheck(!check);
                      showPicker();
                    }}
                    checked={check}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    offColor='#707070'
                    onColor='#49c85a'
                  />
                  <label
                    class='custom-control-label'
                    for='customSwitch1'
                  ></label>
                </div>
              </li>
              <li>
                <p>Match day and night color:</p>
                <div class='custom-control custom-switch'>
                  <Switch
                    onChange={() => setMatchColors(!matchColors)}
                    checked={matchColors}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    offColor='#707070'
                    onColor='#49c85a'
                  />
                  <label
                    class='custom-control-label'
                    for='customSwitch2'
                  ></label>
                </div>
              </li>
              <li>
                <p>(Doppler is currently in night mode.)</p>
              </li>
              <li>
                <p>Display day color</p>
                <ColorPicker
                  color={hexColor}
                  alpha={100}
                  placement='topLeft'
                  enableAlpha={false}
                  // onChange={changeHandler}
                  // onClose={closeHandler}
                />
              </li>
              <li>
                <p>Display night color</p>
                <ColorPicker
                  color={matchColors ? hexNight : hexNight === hexColor}
                  alpha={100}
                  placement='topLeft'
                  enableAlpha={false}
                  // onChange={changeHandler}
                  // onClose={closeHandler}
                />
              </li>
              {show ? (
                <li>
                  <p>Buttons day color</p>
                  <ColorPicker
                    color={check ? btnDayHex : btnDayHex === hexColor}
                    alpha={100}
                    placement='topLeft'
                    enableAlpha={false}
                    // onChange={changeHandler}
                    // onClose={closeHandler}
                  />
                </li>
              ) : null}
              {show ? (
                <li>
                  <p>Buttons night color</p>
                  <ColorPicker
                    color={check ? btnNightHex : btnNightHex === hexNight}
                    alpha={100}
                    placement='topLeft'
                    enableAlpha={false}
                    // onChange={changeHandler}
                    // onClose={closeHandler}
                  />
                </li>
              ) : null}
            </ul>
            <a href='#' class='white-btn mt-5'>
              Restore to defaults
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};
export default DopplerColor;
